const devDomains = ['dev.app.commandojoes.co.uk', 'localhost', '127.0.0.1'];
export const isDevEnvironment = import.meta.env.MODE === 'development' || devDomains.includes(window.location.hostname);
